import { BetslipV2OptionMarketPick } from '../../../../../core/picks/betslip-v2-option-market-pick';
import { CombinationPrevention } from '../../../../../core/picks/combo-prevention';
import { BaseComboPrevention } from './combo-prevention';
import { ComboPreventionResult } from './combo-prevention-result.enum';

/**
 * Validates V1 pick and V1 pick if are compatible for combo.
 */
export class V2SportComboPrevention extends BaseComboPrevention<BetslipV2OptionMarketPick, BetslipV2OptionMarketPick> {
    constructor() {
        super(BetslipV2OptionMarketPick, BetslipV2OptionMarketPick);
    }

    private isSameEvent(x: BetslipV2OptionMarketPick, y: BetslipV2OptionMarketPick): boolean {
        return x.fixture.fixtureId === y.fixture.fixtureId;
    }

    private isSameLeague(x: BetslipV2OptionMarketPick, y: BetslipV2OptionMarketPick): boolean {
        return x.fixture.league?.id === y.fixture.league?.id;
    }

    validate(thisPick: BetslipV2OptionMarketPick, otherPick: BetslipV2OptionMarketPick, isSystemBet: boolean): ComboPreventionResult {
        // combo bets with options from same Market are not allowed

        if (thisPick.market.id === otherPick.market.id) {
            return ComboPreventionResult.SameMarket;
        }

        switch (thisPick.market.comboPrevention) {
            case CombinationPrevention.NoCombo:
                return ComboPreventionResult.NoComboAllowed;

            case CombinationPrevention.NoSportCombo:
                if (thisPick.fixture.sportId === otherPick.fixture.sportId) {
                    return ComboPreventionResult.SameSport;
                }
                break;
            case CombinationPrevention.NoCompetitionCombo:
                if (this.isSameLeague(thisPick, otherPick)) {
                    return ComboPreventionResult.SameLeague;
                }
                break;
            case CombinationPrevention.NoFixtureCombo:
            case CombinationPrevention.OnlyDifferentLiveEvents:
                if (this.isSameEvent(thisPick, otherPick)) {
                    return ComboPreventionResult.SameEvent;
                }
                break;
            case CombinationPrevention.OnlySameLeagueDifferentEvent: // only within same league but different event!
                if (thisPick.fixture.fixtureId === otherPick.fixture.fixtureId || thisPick.fixture.league?.id !== otherPick.fixture.league?.id) {
                    return ComboPreventionResult.DifferentLeague;
                }
                break;
            case CombinationPrevention.NoGroupCombo:
                if (thisPick.fixture.competitionGroupId && thisPick.fixture.competitionGroupId === otherPick.fixture.competitionGroupId) {
                    return ComboPreventionResult.SameGroup;
                }
                break;
        }

        return ComboPreventionResult.AllCombo;
    }
}
